import type {
  ServiceAlias,
  ServiceAliasSyncStatus,
  ServiceAliasPrimaryOwnerConnectionStatus,
} from '@liscio/api'

export type PaginationData = {
  current_page: number
  total_pages: number
  total_entries: number
  per_page: number
}

// Consume the generated V5 client as the source of truth for the API contract —
// don't hand-maintain a shadow ServiceAlias. Re-exported so the SmartVault
// modules keep importing it from one local place.
export type { ServiceAlias }

// Non-null sync-health states (the chip handles null separately). Derived from
// the generated ServiceAliasSyncStatus so values stay in lockstep with the API.
export type SyncStatus = NonNullable<ServiceAliasSyncStatus>

// Non-null primary_owner connection-health states (LISD-2590). Derived from the
// generated enum so values stay in lockstep with the API.
export type ConnectionStatus = NonNullable<ServiceAliasPrimaryOwnerConnectionStatus>

export type ServiceAliases = ServiceAlias[]

export const defaultPagination: PaginationData = {
  current_page: 0,
  total_pages: 0,
  total_entries: 0,
  per_page: 0
};

export const defaultServiceAlias: ServiceAlias = {
  id: 0,
  aliasable: {
    name: ''
  },
  aliasable_id: 0,
  aliasable_type: '',
  cpa_id: 0,
  created_at: '',
  external_folder_path: '',
  external_id: '',
  service_id: '',
  external_name: '',
  primary_owner: null,
  confirmed: false,
  sync_status: null,
  primary_owner_connection_status: null,
  last_run_at: null
}

export type ModalProps = {
  closeModal: () => void
  serviceAlias: ServiceAlias
  serviceAliasData: ServiceAlias[]
  setServiceAliasData: (serviceAliases: ServiceAlias[]) => void
}

// Liscio-account selector (EditLinkingModal): value is the numeric account id.
export type SelectOption = {
  label: string
  value: number
}

// SmartVault account-search dropdown (SmartVaultAccountLinks): value is the
// account's external_id (a string), passed straight to the service_aliases
// index `external_id` query param.
export type AccountSearchOption = {
  label: string
  value: string
}
